import { render, staticRenderFns } from "./billing-info-v2-items.component.vue?vue&type=template&id=36fd1086&scoped=true&"
import script from "./billing-info-v2-items.component.vue?vue&type=script&lang=ts&"
export * from "./billing-info-v2-items.component.vue?vue&type=script&lang=ts&"
import style0 from "./billing-info-v2-items.component.vue?vue&type=style&index=0&id=36fd1086&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fd1086",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTab,VTabItem,VTabs,VTabsItems,VTextField})
